import type { ImageSet } from "@pax/api-contract/common";
import { srcSet } from "@/lib/images";

/** A profile's banner, filling its frame. `sizes` is how wide the frame is drawn, which picks the file the browser loads. */
export function ProfileBanner({ banner, sizes }: { banner: ImageSet; sizes: string }) {
  return (
    <img
      src={banner.sources[0].url}
      srcSet={srcSet(banner)}
      sizes={sizes}
      alt=""
      className="size-full object-cover"
    />
  );
}
